<template>
  <div>
    <div class="mb-1 d-flex justify-content-between">
      <div>
        <b-button v-if="showCreateReturn" class="mr-1" @click="openModal('modalCreateReturn')" variant="warning">{{ $t('Generar devolución') }}
        </b-button>
        <b-button v-if="showGoReturn" class="mr-1" @click="goReturn()" variant="warning">{{ $t('Ver devolución') }}</b-button>
        <b-button v-if="showChangeStatus" class="mr-1" @click="openModal('changeStatusModal')" variant="warning"> <feather-icon icon="ArchiveIcon"/> {{ $t('Cambiar estado') }}</b-button>
        <b-button v-if="showDeleteButton" class="mr-1" @click="openModal('deleteDeliveryModal')" variant="danger"> <feather-icon icon="TrashIcon"/> {{ $t('Eliminar') }}</b-button>
        <b-button v-if="showChangeStatusPudo" class="mr-1" @click="postStatusChangePudo()" :disabled="statusPudo.disabledButton" :variant="statusPudo.colorButton"> <feather-icon icon="ArchiveIcon"/> {{ $t(statusPudo.nameButton) }}</b-button>
      </div>
      <div v-if="showDeliveryAttempts" class="d-flex flex-column align-items-center">
        <span style="font-size:10px; color:#165191; margin-bottom:2px">Intentos de entrega</span>
        <b-avatar id="avatar" square badge badge-top badge-offset="-0.4em" :badge-variant="colorBadge" variant="white" src="/attempts-image.png" size="30px">
          <template #badge>{{qtyBadge}}</template>c
        </b-avatar>
      </div>
    </div>
    <div></div>
    <h5 v-show="!!isMeliFlex" class="customize-h5">Mercado Libre</h5>
    <table-render
    v-if="!loading.first"
    :rows="rows"
    :schema="schema"
    :show-checkboxes="false"
    :stickyHeader="`calc(100vh - 2.5rem)`"
    id="status_history">
      <template #delivery_status_name="scope">
        <span > {{scope.rowdata.delivery_status_name}} <feather-icon v-if="showIconDeliveryStatus(scope)" size="16" icon="AlertCircleIcon" style="margin-bottom: 2px; color: #ea5455"/> </span>
        <a target="_blank" :href="delivery.delivery.extra_fields.url_live_tracking.value" v-if="hasUrl && (scope.rowdata.delivery_status_id === 5 || scope.rowdata.delivery_status_id === 62)"> <feather-icon icon="MapPinIcon" style="color: #337ab7"/> </a>
      </template>
      <template #created_at="scope">
        {{scope.rowdata.created_country_timezone || scope.rowdata.created_at}}
      </template>
      <template #info="scope">
        {{scope.rowdata.json_data || 'Sin información'}}
      </template>
      <template #comment="scope">
        {{scope.rowdata.comment || 'Sin comentario'}}
      </template>
    </table-render>
    <hr v-show="!!isMeliFlex" style="padding-bottom: 0.5em;">
    <div v-show="!!isMeliFlex && loading.secondTracking" class="customize-title">
      <h5 class="customize-h5">{{childCarrier.name}}</h5>
      <p>(Secundario)</p>
      <b-button variant="link" v-b-toggle.secondHistoryTrk @click="changeIconToggle()">
        <feather-icon
          :icon="iconToggle ? 'ChevronUpIcon' : 'ChevronDownIcon'"
          size="20"/>
      </b-button>
    </div>
    <b-collapse id="secondHistoryTrk">
      <table-render
      :schema="schema"
      :rows="rowsSecondaryTracking"
      :show-checkboxes="false"
      :stickyHeader="`calc(100vh - 2.5rem)`"
      id="status_history2">
      <template #delivery_status_name="scope">
          <span > {{scope.rowdata.delivery_status_name}} <feather-icon v-if="showIconDeliveryStatus(scope)" size="16" icon="AlertCircleIcon" style="margin-bottom: 2px; color: #ea5455"/> </span>
          <a target="_blank" :href="delivery.delivery.extra_fields.url_live_tracking.value" v-if="hasUrl && (scope.rowdata.delivery_status_id === 5 || scope.rowdata.delivery_status_id === 62)"> <feather-icon icon="MapPinIcon" style="color: #337ab7"/> </a>
      </template>
      <template #created_at="scope">
            {{scope.rowdata.created_country_timezone || scope.rowdata.tracking_date}}
      </template>
      <template #info="scope">
        {{ !!isMeliFlex && scope.rowdata.tracking_json_data ? scope.rowdata.tracking_json_data.info : 'Sin información' }}
      </template>
      <template #comment="scope">
            {{scope.rowdata.comment || 'Sin comentario'}}
      </template>
    </table-render>
    </b-collapse>
    <div class="table-render-skeleton" v-show="loading.first">
      <b-skeleton-table
        :rows="4"
        :columns="schema.length || 4"
        :table-props="{}"
      />
    </div>
    <modals
    id="changeStatusModal"
    :dataModal="modalsStatus"
    @onSend="postStatusChange"
    @show="onShowStatus">
    </modals>
    <!-- <modals
    id="modalCreateReturn"
    :dataModal="modalsReturn"
    @onSend="onSend"
    @show="onShowReturn">
    </modals> -->
    <modals
    id="deleteDeliveryModal"
    :dataModal="modalsDelete"
    @onSend="postStatusChange"
    @show="onShowStatusDelete">
    </modals>
    <ModalCreateReturns
    :dataModal="modalsReturn"
    ref="modalCreateReturn"
    id="modalCreateReturn"
    @show="onShowReturn"
    @onSend="onSend"></ModalCreateReturns>
  </div>
</template>

<script>
import { BCollapse, VBToggle } from 'bootstrap-vue'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import { mapGetters } from 'vuex'
import Modals from '../Modals.vue'
import { environment } from '@/environments/environment'
import ModalCreateReturns from '../ModalCreateReturns.vue'
export default {
  components: { Modals, FeatherIcon, BCollapse, ModalCreateReturns },
  directives: { 'b-toggle': VBToggle },
  name: 'history-status',
  props: {
    showDeleteButton: {
      type: Boolean,
      default: true
    },
    showChangeStatus: {
      type: Boolean,
      default: true
    },
    dataAccount: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      schema: [],
      keyTableRender: 0,
      rows: [],
      rowsSecondaryTracking: [],
      loading : {
        first: false,
        secondTracking: false
      },
      statusPudo: {
        disabledButton: false
      },
      modalsReturn: {
        fields: [
          {fieldType: 'FieldInput', label:  this.$t('Correo'), name: 'email', containerClass: 'container-info col-sm-12', validation: 'required' },
          {fieldType: 'FieldSelect', label: this.$t('Courier'), name: 'carrier', clearable: true, containerClass: 'container-info col-sm-12', validation: 'required' },
          {fieldType: 'FieldInput', label: this.$t('Número de bultos a devolver'), name: 'n_packages', clearable: false, containerClass: 'container-info col-sm-12', validation: 'required', type: 'number', useSlot: true }
        ],
        nameButton: 'Generar',
        title: 'Generar devolución',
        form: {},
        loading: false,
        key: 0
      },
      modalsStatus: {
        fields: [
          {fieldType: 'FieldSelect', name: 'status', label: 'Nuevo estado', containerClass: 'col-12 container-info', useLabel: true, clearable: true, change: this.changeOrganization, validation: 'required'},
          {fieldType: 'FieldTextarea', name: 'comment', label: 'Comentario', containerClass: 'col-12 container-info', useLabel: true, clearable: true }
        ],
        nameButton: 'Agregar',
        title: 'Cambiar estado de envío',
        form: {},
        loading: false,
        key: 0,
        isEnableButton: true
      },
      modalsDelete: {
        fields: [
          {name:'status'},
          {fieldType: 'FieldTextarea', name: 'comment', label: 'Comentario', containerClass: 'col-12 container-info', useLabel: true, clearable: true }
        ],
        nameButton: 'Eliminar',
        title: 'Eliminar envío',
        form: {},
        loading: false,
        key: 0,
        isEnableButton: true
      },
      carriersReturns: [],
      iconToggle: false
    }
  },
  computed: {
    ...mapGetters({
      delivery: 'getDeliveryDetails',
      carriers: 'getCourierConfiguration',
      generalLoading: 'getLoading'
    }),
    showDeliveryAttempts() {
      return !!this.delivery?.delivery_attempts?.qty
    },
    colorBadge() {
      const color = Object.freeze({
        green: 'success',
        orange: 'warning',
        red: 'danger'
      })
      return color[this.delivery?.delivery_attempts?.color] ?? ''
    },
    qtyBadge() {
      return this.delivery?.delivery_attempts?.qty
    },
    canAccessReturns() {
      return !!this.dataAccount?.legacy_data?.can_access_return
    },
    showCreateReturn() {
      return this.canAccessReturns && this.delivery?.delivery?.return_delivery_id === null && !this.$session.get('cas_user').special_permissions.includes('lock-return-from-delivery') && [10].includes(this.delivery?.delivery?.delivery_status_id)
    },
    showGoReturn() {
      return this.canAccessReturns && !!this.delivery?.delivery?.return_delivery_id && this.delivery?.delivery?.delivery_status_id === 10
    },
    hasUrl() {
      return !!this.delivery?.delivery?.extra_fields?.url_live_tracking?.value
    },
    statuses() {
      if (this.delivery?.delivery?.pudo) {
        return this.delivery?.statuses?.pudo?.filter(status => [13, 44].includes(status.id)).map((status) => ({ text: status?.name, id: status?.id, ...status }))
      }
      return this.delivery?.statuses?.home?.map((status) => ({ text: status?.name, id: status?.id, ...status }))
    },
    statusLogs() {
      if (this.delivery?.delivery?.delivery_status_log && typeof this.delivery?.delivery?.delivery_status_log === 'object') {
        return Object.values(this.delivery?.delivery?.delivery_status_log)
      }
      return this.delivery?.delivery?.delivery_status_log
    },
    showChangeStatusPudo() {
      if (!this.delivery?.delivery) return false
      this.setStatusPudoChangeButton(this.delivery.delivery)
      return [1, 5, 7, 9, 11, 13, 26, 75, 54, 29].includes(this.delivery?.delivery?.delivery_status_id) && (this.delivery.delivery?.pudo_id && ['pudo', 'admin'].includes(this.$session.get('cas_user').role))
    },
    isCourierInt() {
      return this.delivery?.delivery?.carrier?.code === 'INT'
    },
    isMkpCenco() {
      return this.delivery?.delivery?.marketplace_id === 1162
    },
    isMeliFlex() {
      return this.delivery?.special_type?.type?.toLowerCase() === 'meliflex'
    },
    secondaryTrackingsMflex() {
      return this.delivery?.delivery_carrier_trackings ? this.delivery?.delivery_carrier_trackings?.filter(trk => trk.carrier_code !== 'MKC' && trk.delivery_status_id !== 15) : null
    },
    childCarrier() {
      const carrierCode = this.delivery?.delivery?.extra_fields?.child_carrier_code?.value ?? null
      const carrierInfo = this.carriers?.filter(carrier => carrier.carrier_code === carrierCode?.toUpperCase()) ?? null

      const childCarrierTrk = {
        code: carrierCode,
        name: carrierInfo[0]?.carrier_name
      }

      return childCarrierTrk ?? null
    },
    qtyPkg () {
      return this.delivery?.delivery?.n_packages
    },
    isMultiPkg () {
      return this.delivery?.delivery?.n_packages > 1
    }
  },
  watch: {
    generalLoading: {
      handler () {
        this.loading.first = !!this.generalLoading.getDeliveryDetails
        this.modalsReturn.loading = !!this.generalLoading.postCreateReturn
        this.modalsStatus.loading = !!this.generalLoading.postChangeStatusDelivery
        this.modalsDelete.loading = !!this.generalLoading.postChangeStatusDelivery
      },
      deep: true
    },
    delivery() {
      this.modalsReturn.fields[2].maxValue = this.qtyPkg
      this.modalsReturn.fields[2].disabled = !this.isMultiPkg
    },
    statusLogs(val) {
      this.rows = val?.map(el => ({
        ...el,
        user_e: el.changed_by || el.user_email || 'Sin información'
      }))
    },
    secondaryTrackingsMflex(val) {
      this.rowsSecondaryTracking = val.filter((trk) => !!trk.delivery_status_id).map(trk => ({
        ...trk,
        user_e: trk.tracking_json_data?.user || 'Sin información',
        info: trk?.tracking_json_data?.info
      })).sort((firstDate, secondDate) => {
        const fDateIso = firstDate.tracking_date.replace(' ', 'T')
        const SDateIso = secondDate.tracking_date.replace(' ', 'T')
        return new Date(fDateIso).getTime() - new Date(SDateIso).getTime()
      }).reverse()

    },
    showCreateReturn() {
      if (!!this.showCreateReturn) {
        const services = [
          { name: 'getCarriersReturns', queryParams: {shipper_id: this.delivery?.delivery?.company?.id}, hideAlert: true }
        ]
        this.$store.dispatch('fetchMultipleServices', {services, onSuccess: (res) => { this.setCarriersReturns(res[0].data) }, onError: (err) => console.error(err)})
      }
    },
    'childCarrier.name'() {
      this.loading.secondTracking = this.childCarrier.name !== null ?? false
    }
  },
  mounted() {
    this.setInitialData()
    this.rows = this.statusLogs?.map(el => ({
      ...el,
      user_e: el.changed_by || el.user_email || 'Sin información'
    }))
    this.rowsSecondaryTracking = this.secondaryTrackingsMflex?.map(el => ({
      ...el,
      user_e: el.changed_by || el.user_email || 'Sin información'
    }))
  },
  methods: {
    setInitialData () {
      this.schema = [
        {label: 'Estado', sortable: true, key: 'delivery_status_name', useSlot: true},
        {label: 'Fecha', sortable: true, key: 'created_at', useSlot: true},
        {label: 'Comentario', sortable: true, key: 'comment', useSlot: true},
        {label: 'Detalle', sortable: true, key: 'info', useSlot: true},
        {label: 'Usuario', sortable: true, key: 'user_e'}
      ]
    },
    showIconDeliveryStatus(scope) {
      return [4, 112].includes(scope?.rowdata?.delivery_status_id) || scope?.rowdata?.delivery_status_trouble || scope?.rowdata?.comment?.includes('SKU no enviados a fulfillment')
    },
    goReturn() {
      this.$router.push({ name: 'return-details', params: { id: this.delivery?.delivery?.return_delivery_id } })
    },
    openModal(name) {
      this.$bvModal.show(name)
    },
    fetchCreateReturn(form) {
      const data = {
        name: 'postCreateReturn',
        params: { delivery_id: this.$route.params.id },
        queryParams: { ...form }
      }
      this.$store.dispatch('fetchService', data)
    },
    postStatusChange(form) {
      const data = {
        name: 'postChangeStatusDelivery',
        params: { delivery_id: this.delivery?.delivery?.id },
        queryParams: { id: form?.status?.id, comment: form?.comment },
        onSuccess: () => {
          this.$emit('getDelivery')
          this.$bvModal.hide('changeStatusModal')
          this.$bvModal.hide('deleteDeliveryModal')
        },
        onError: () => {
          this.modalsStatus.loading = false
          this.modalsDelete.loading = false
        }
      }
      this.$store.dispatch('fetchService', data)
    },
    onShowReturn() {
      const { fields, form } = this.modalsReturn
      form.email = this.delivery?.delivery?.email
      fields.find((field) => field.name === 'carrier').options = this.carriersReturns?.map((carrier) => ({ id: carrier.code, text: carrier.name }))
      this.modalsReturn.form.n_packages = this.qtyPkg
      this.modalsReturn.key++
    },
    onSend(form) {
      const carrier = this.carriers.find((field) => field.carrier_code === form.carrier.id)
      const data = {
        name: 'postCreateReturn',
        params: { delivery_id: this.$route.params.id },
        queryParams: {
          email: form.email,
          carrier
        },
        onError: () => this.modalsReturn.loading = false,
        onSuccess: () => { this.$emit('getDelivery'); this.$bvModal.hide('modalCreateReturn') }
      }
      if (form.n_packages) data.queryParams['n_packages'] = form.n_packages
      this.$store.dispatch('fetchService', data)
    },
    onShowStatus() {
      const { fields } = this.modalsStatus
      fields.find((field) => field.name === 'status').options = this.statuses
      this.modalsStatus.key++
    },
    onShowStatusDelete() {
      const keyStatus = Object.keys(this.delivery?.statuses?.home)
      this.modalsDelete.form.status = this.delivery?.statuses?.home[keyStatus[0]]
      this.modalsDelete.key++
    },
    setStatusPudoChangeButton(delivery) {
      if ([1, 5, 7, 9, 26, 75].includes(delivery.delivery_status_id)) {
        this.statusPudo.colorButton = 'info'
        this.statusPudo.nameButton = 'Cambiar a disponible para retiro'
      } else if ([11, 54, 29].includes(delivery.delivery_status_id)) {
        this.statusPudo.colorButton = 'warning'
        this.statusPudo.nameButton = 'Cambiar a retirado por cliente'
      } else if ([10, 13].includes(delivery.delivery_status_id)) {
        this.statusPudo.colorButton = 'primary'
        this.statusPudo.nameButton = 'Comprobante'
      } else {
        this.statusPudo.disabledButton = true
      }
    },
    postStatusChangePudo() {
      if ([10, 13].includes(this.delivery.delivery.delivery_status_id)) {
        window.open(`${environment.apiPlatform}/v1/deliveries/${this.delivery.delivery.id}/voucher`, '_blank')
      } else {
        const form = {}
        if ([1, 5, 7, 9, 26, 75].includes(this.delivery.delivery.delivery_status_id)) {
          form.status = { id: 11, comment: 'Cambio a estado "Disponible para retiro" desde detalle de envio' }
        } else if ([11, 54, 29].includes(this.delivery.delivery.delivery_status_id)) {
          form.status = { id: 13, comment: 'Cambio a estado "Entregado" desde detalle de envio' }
        } else {
          this.$alert(this.$t('msg-cant-change-status-pudo'))
          return
        }
        this.postStatusChange(form)
      }
    },
    setCarriersReturns(carriers) {
      this.carriersReturns = carriers.filter(carrier => carrier.services.some(service => service.is_return))
      if (this.isMkpCenco) {
        this.carriersReturns = this.isCourierInt ? carriers.filter(carrier => carrier.code === 'INT') : carriers.filter(carrier => carrier.code === 'BLX')
      }
    },
    changeIconToggle() {
      this.iconToggle = !this.iconToggle
    }
  }
}
</script>

<style>
  .table-render-skeleton {
    overflow-x: hidden !important;
  }
  #avatar > span > img {
    width: 25px;
    height: 25px;
  }
  .customize-title {
    display: flex;
    align-items: baseline;
    gap: 0.2em
  }
  .customize-title h5 {
    align-self: center;
  }
  .customize-title p {
    font-size: smaller;
    line-height: 0;
  }
  .customize-title button {
    padding: 0 ;
  }
  .customize-title button .feather {
    vertical-align: top;
  }
  .customize-h5 {
    padding-bottom: 0.6em;
  }
</style>